import React from 'react';
import styled from '@emotion/styled';
import Img from 'gatsby-image';

import respond from '../../styles/mediaQueries';

const ImageContainer = styled('div')`
	margin-left: 4rem;
	width: auto;

	${respond('bp4')} {
		width: 100%;
		height: 100%;
		margin-left: 0;
	}
	
	& img {
		width: 100%;
		margin-bottom: 4rem;
	}
`;

const Links = styled('div')` 
	display: flex;
	justify-content: flex-end;
	border-top: .3rem solid var(--textInverse2);
	padding-top: .8rem;
	margin-top: 2.4rem;

	& a {
		margin-left: 2.4rem;
	}
`;

const PageHeaderImage = ({ image, alt, children }) => {
	return (
		<ImageContainer>
			<Img fluid={image.childImageSharp.fluid} alt={alt} />
			<Links>{children}</Links>
		</ImageContainer>
	);
};

export default PageHeaderImage;
